var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      !_vm.isWhiteLabel)?_c('div',{staticClass:"loading-screen",class:{'dark':_vm.isDarkTheme}},[_c('aha-logo-loader')],1):_c('div',{staticClass:"loading-screen-white-label",class:{'dark':_vm.isDarkTheme}},[_c('div',[_c('aha-spinner',{attrs:{"size":"lg","variant":"tail"}})],1),_c('p',{staticClass:"mt-6"},[_vm._v("\n      Just a moment please...\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }